import script from "./address-table-row.vue?vue&type=script&setup=true&lang=ts"
export * from "./address-table-row.vue?vue&type=script&setup=true&lang=ts"

import "./address-table-row.vue?vue&type=style&index=0&id=7e24a761&lang=scss"

const __exports__ = script;

export default __exports__